import { render, staticRenderFns } from "./MessageDialog.vue?vue&type=template&id=610c0efd&scoped=true&"
import script from "./MessageDialog.vue?vue&type=script&lang=ts&"
export * from "./MessageDialog.vue?vue&type=script&lang=ts&"
import style0 from "./MessageDialog.vue?vue&type=style&index=0&id=610c0efd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610c0efd",
  null
  
)

export default component.exports